import { getConfig } from '@cian/config/browser';
import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState } from '../../../shared/types/redux';

export function createApplicationState() {
  const config = getConfig();

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, true);
}
